import { render, staticRenderFns } from "./IntegrationsSettings.vue?vue&type=template&id=8ba367b4&scoped=true&"
import script from "./IntegrationsSettings.vue?vue&type=script&lang=js&"
export * from "./IntegrationsSettings.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsSettings.vue?vue&type=style&index=0&id=8ba367b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba367b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VIcon,VRow})
